<template>
  <CalicoOnboarding
    :loading="loading"
    :form-data="formData"
    @save="save"
  >
    <div class="verify-ownership">
      <SelectedBusiness
        :business="business"
        @change="changeBusiness"
      />
      <div class="information">
        <h3 class="heading--xsmall">
          Company Formation Documents
        </h3>
        <div class="body--medium">
          <p>
            Upload <b>Articles of Incorporation</b> (or <b>Certificate of Incorporation</b>) and/or <b>Bylaws</b>,
            which are registered with the Secretary of State. These documents should verify:
          </p>
          <ul>
            <li>Business Name</li>
            <li>Owner(s) Name</li>
            <li>Business Address</li>
            <li>Business Phone</li>
            <li>Business Email</li>
            <li>Entity</li>
            <li>EIN</li>
          </ul>
        </div>
      </div>
      <CalicoForm 
        name="file"
        label="Document"
        rules="required"
      >
        <CalicoUploadFile
          :size="10"
          :file="formData.file"
          :accept="'.pdf, .png, .jpeg'"
          @browse="(files) => handleFileUpload(files[0])"
          @cancel="cancel"
          @trash="remove"
        />
      </CalicoForm>
    </div>
  </CalicoOnboarding>
</template>
<script>
import CalicoUploadFile from '@/components/pattern/uploadFile/index.vue'
import CalicoOnboarding from "@/components/template/onboarding/index.vue";
import SelectedBusiness from '@/components/pattern/selectedBusiness/index.vue'
import CalicoForm from "@/components/pattern/form/index.vue";
import services from '@/services';

export default {
  name: 'VerifyOwnerShipScreen',
  components: {
    CalicoOnboarding,
    SelectedBusiness,
    CalicoUploadFile,
    CalicoForm
  },
  data() {
    return {
      formData: {
        file: null,
      },
      business: {},
      loading: true
    }
  },
  async mounted() {
    await this.setFile()
    this.business = await services.user.business.get();
    this.loading = false
  },
  methods: {
    async save(next) {
      next();
    },
    async setFile() {
      this.formData.file = await services.user.business.document.get()
    },
    async handleFileUpload(file) {
      if (this.formData.file?.id) {
        services.user.deleteDocument(this.formData.file?.id)
      }
      this.formData.file = file

      const formData = new FormData();
      formData.append('file', this.formData.file.file);

      document.instance = services.user.business.document.instance(formData, (response) => {
        if (isNaN(response)) {
          this.formData.file = JSON.parse(response)
        } else {
          this.formData.file.progress = Number(response)
        }
      })
      document.instance.upload()
        .catch((error) => {
          this.formData.file.state = 'failed'
          this.formData.file.message = error.message
        })
    },
    cancel(document) {
      document.instance.cancel()
    },
    remove(document) {
      this.formData.file = null
      services.user.business.document.delete(document.id)
    },
    changeBusiness() {
      this.$router.push('/kyb/claim-business');
    },
  }
}
</script>

<style scoped lang="scss">
.verify-ownership {
  @include stack-space($space-large);
  padding: $space-large;
  .information {
    @include stack-space($space-small);
    ul {
      list-style-type: square;
      padding-left: 20px;
      li::marker {
        font-size: $space-small;
      }
    }
    p {
      margin: 0;
    }
  }
}
</style>